<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="modal-contacto">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">Formulario Para el Registro de Contacto de feria</h4>
        </div>
        <div class="modal-body">
          <multiselect
            class="form-control form-group-sm mb-4"
            style="width:100%"
            :options="canales"
            v-model="canal"
            track-by="id"
            label="text"
            :searchable="true"
            :close-on-select="true"
            :multiple="false" 
            :show-labels="false"
            placeholder="* Seleccione el canal de contacto"
          />

          <v-text-field outlined dense autofocus v-model.trim="contacto.numero_documento" :counter="30" label="Carnet"></v-text-field>
          <v-text-field outlined dense :counter="30" v-model.trim="contacto.nombres" label="* Nombres" :rules="fieldRules"></v-text-field>
          <v-text-field outlined dense :counter="25" v-model.trim="contacto.primer_apellido" label="* Primer Apellido" :rules="fieldRules"></v-text-field>
          <v-text-field outlined dense :counter="25" v-model.trim="contacto.segundo_apellido" label="Segundo Apellido"></v-text-field>
          <v-text-field outlined dense :counter="20" v-model.trim="contacto.telefono" label="* Telefono" :rules="fieldRules"></v-text-field>
          <v-text-field outlined dense :counter="100" v-model.trim="contacto.correo" type="email" label="Correo"></v-text-field>
          <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :rules="fieldRules"
                readonly
                label="* Fecha de visita:"
                v-model="contacto.fecha_visita"
                outlined
                dense
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" locale="es-ES" @input="menu1 = false" :max="maxDate()" :min="minDate()"></v-date-picker>
          </v-menu>
          <v-combobox
            v-model="city"
            prepend-inner-icon="mdi-city"
            clearable
            outlined
            dense
            small-chips
            label="* Ciudad"
            :rules="fieldRules"
            :items="ciudades"
            item-text="nombre"
            :search-input.sync="searchCity"
          >
            <template v-slot:selection="{ attrs, item, selected, parent }">
              <v-chip :key="item.id" v-bind="attrs" :input-value="selected" @click:close="parent.selectItem(item.nombre)">
                <v-avatar v-if="item && item.nombre" class="accent white--text" left v-text="item.nombre.slice(0, 1).toUpperCase()"></v-avatar>
                {{ item.nombre }}
              </v-chip>
            </template>
          </v-combobox>

          <!-- {{ postgrados }} -->
          <v-combobox
            v-model="postgrado"
            prepend-inner-icon="mdi-database-search"
            multiple
            clearable
            outlined
            dense
            label="* Intereses"
            :items="postgrados"
            item-text="nombre"
            :search-input.sync="searchPostgrado"
            :rules="fieldRules"
            :error-messages="ruleInteres"
          >
            <template v-slot:selection="{ attrs, item, selected, parent }" if>
              <v-chip close :key="Math.random()" v-bind="attrs" :input-value="selected" @click:close="parent.selectItem(item)">
                {{ item.nombre || item }}
              </v-chip>
            </template>
            <template v-slot:no-data v-if="searchPostgrado.length > 2">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    Interes No encontrada " <strong>{{ searchPostgrado }} </strong>". Presione <kbd>Enter</kbd> para añadir
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>
          <v-combobox
            v-model="profesion"
            prepend-inner-icon="mdi-account-tie"
            clearable
            outlined
            dense
            small-chips
            label="Profesion"
            :items="profesiones"
            item-text="nombre"
            :search-input.sync="searchProfesion"
          >
            <template v-slot:no-data v-if="searchProfesion">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    Profesion No encontrada "<strong>{{ searchProfesion }}</strong
                    >". Presione <kbd>Enter</kbd> para añadir
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>

          <v-combobox
            v-model="empresa"
            prepend-inner-icon="mdi-home-city"
            clearable
            outlined
            dense
            small-chips
            label="Empresa de Trabajo"
            :items="empresas"
            item-text="nombre"
            :search-input.sync="searchEmpresa"
          >
            <template v-slot:no-data v-if="searchEmpresa">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    Empresa No encontrada "<strong>{{ searchEmpresa }}</strong
                    >". Presione <kbd>Enter</kbd> para añadir nueva empresa
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item> 
            </template>
          </v-combobox>
          <v-text-field outlined dense :counter="100" v-model.trim="contacto.direccion" label=" Direccion"></v-text-field>
          <v-text-field outlined dense :counter="100" prepend-icon="mdi-comment" v-model.trim="contacto.observacion" label=" Observacion"></v-text-field>

          <p class="text-center text-danger">{{ msg }}</p>
        </div>
        <div class="modal-footer">
          <v-btn class="ma-1" outlined small rounded data-dismiss="modal">Cerrar</v-btn>
          <v-btn class="ma-1" color="info" small rounded @click="reset()">limpiar formulario</v-btn>
          <v-btn class="ma-1" color="success" small rounded @click="validardatos()">Guardar cambios</v-btn>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script>
import {getheadersrest} from '@/components/Utils';
import gql from 'graphql-tag';
import { validationMixin } from 'vuelidate';

export default {
  mixins: [validationMixin],

  props: { padre: { type: Object, required: false }, listado: { type: Array, required: false } },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      fieldRules: [(v) => !!v || 'Campo Obligatorio'],
      emailRules: [(v) => (v ? /.+@.+\..+/.test(v) || 'E-mail no válido' : false)],
      msg: '',
      subiendo: false,
      contacto: {
        numero_documento: '',
        nombres: '',
        primer_apellido: '',
        segundo_apellido: '',
        telefono: '',
        correo: '',
        empresa: '',
        profesion: '',
        asesor_id: '',
        fecha_visita: '',
        estado: 'Interesado',
        latitud: '',
        longitud: '',
        ciudad: '',
        direccion: '',
        observacion: '',
        intereses: '',
      },
      city: null,
      searchCity: '',
      ciudades: [],

      empresa: null,
      searchEmpresa: '',
      empresas: [],

      profesion: null,
      searchProfesion: '',
      profesiones: [],

      postgrado: null,
      searchPostgrado: '',
      postgrados: [],
      canales:[
        {id:1, text:'FEXPO CRUZ'},
        {id:2, text:'FEXPO SUCRE'},
        {id:3, text:'EXPOSUR'},
      ],
      canal: null,
    };
  },
  validations: {
    contacto: {
      intereses: {
        isLong(intereses) {
          if (intereses === null) return false;
          if (intereses && intereses.length >= 149) return true;
          return new Promise((resolve) => resolve(false));
        },
      },
    },
  },
  computed: {
    ruleInteres() {
      const errors = [];
      this.$v.contacto.intereses.isLong && errors.push(`${this.contacto.intereses.length} / 150,   Demasiados Intereses Seleccionados`);
      return errors;
    },
  },

  watch: {
    'padre.id': function () {
      this.loadc();
    },
    date() {
      this.contacto.fecha_visita = this.formatDate(this.date);
    },
    searchCity(valor = null) {
      if (valor && valor.length > 3) {
        this.getCiudades();
      } else {
        this.ciudades = [];
        this.searchCity = '';
      }
    },
    city(value) {
      this.contacto.ciudad = value ? value.nombre : null;
    },
    searchEmpresa(valor = null) {
      if (valor && valor.length >= 3) {
        this.getEmpresas();
      } else {
        this.empresas = [];
        this.searchEmpresa = '';
      }
    },
    empresa(value) {
      this.contacto.empresa = value ? value.nombre : null;
    },
    searchProfesion(valor = null) {
      if (valor && valor.length > 3) {
        this.getProfesiones();
      } else {
        this.profesiones = [];
        this.searchProfesion = '';
      }
    },
    profesion(value) {
      this.contacto.profesion = value ? value.nombre : null;
    },
    searchPostgrado(valor = null) {
        this.pordefecto();
      if (valor && valor.length > 3) {
        this.getPostgrados(valor);
      } else {
        this.postgrados = []; 
        this.searchPostgrado = '';
      }
    }, 
    postgrado(value) {
      if (value) {
        value = value.map((v) => (v && v.nombre ? v.nombre : v));
        this.contacto.intereses = value.length > 0 ? value.join(',') : null;
      }
    },
  },
  components: {},
  methods: {
    pordefecto(){
        this.postgrados = []; 
        const p = [
            // {id:-1, nombre:'Interes 1'},
            // {id:-2, nombre:'Interes 2'},
            // {id:-3, nombre:'Interes 3'},
            // {id:-4, nombre:'Interes 4'},
            // {id:-5, nombre:'Interes 5'},
            "GOUP",
            "Ciberkids",
            "SIESAM",
            "Diplomado en educación superior basado en Competencias",
        ];
        this.postgrados = p;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    maxDate() {
      return new Date().toISOString().substr(0, 10);
    },
    minDate() {
      let date = new Date();
      let dias = 7;
      date.setDate(date.getDate() - dias);
      return date.toISOString().substr(0, 10);
    },
    validardatos() {
      // window.console.log(this.contacto);
      this.msg = '';
      if (!this.contacto.asesor_id) {
        let idasesor = this.$store.state.DATA_USER.id;
        if (!idasesor) {
          this.msg = 'Id asesor no seleccionado, intente salir y volver a ingresar.';
          return;
        }
        this.contacto.asesor_id = idasesor;
      }
      if(!this.canal) {
        this.msg = 'Seleccione un canal';
        return;
      }
      if (this.contacto.numero_documento && this.contacto.numero_documento.length > 30) this.msg = 'Carnet no valido';
      else if (!this.contacto.nombres || this.contacto.nombres.length > 30) this.msg += 'Nombres no valido. ';
      else if (!this.contacto.primer_apellido || this.contacto.primer_apellido.length > 25) this.msg += 'Apellido1 no valido. ';
      else if (this.contacto.segundo_apellido && this.contacto.segundo_apellido.length > 25) this.msg += 'Apellido2 no valido. ';
      else if (!this.contacto.telefono || this.contacto.telefono.length > 20) this.msg += 'Telefono no valido. ';
      else if (this.contacto.correo && this.contacto.correo.length > 100) this.msg += 'Correo no valido. ';
      else if (this.contacto.empresa && this.contacto.empresa.length > 100) this.msg += 'Empresa no valido. ';
      else if (this.contacto.profesion && this.contacto.profesion.length > 100) this.msg += 'Carnet no valido. ';
      else if (!this.contacto.asesor_id) this.msg += 'Algo salio mal, intenta volver a ingresar a esta pantalla y carga el archivo. ';
      else if (!this.contacto.fecha_visita || !/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/.test(this.contacto.fecha_visita)) this.msg += 'Formato de fecha no valido. ';
      else if (!this.contacto.estado || this.contacto.estado.length > 50) this.msg += 'Estado no valido. ';
      else if (!this.contacto.ciudad || this.contacto.ciudad.length > 100) this.msg += 'Ciudad no valido. ';
      else if (this.contacto.direccion && this.contacto.direccion.length > 100) this.msg += 'Direccion no valido. ';
      else if (this.contacto.observacion && this.contacto.observacion.length > 100) this.msg += 'Observacion no valido. ';
      else if (!this.contacto.intereses || this.contacto.intereses.length == 0) this.msg += 'Escriba al menos 1 interes. ';
      window.console.log("------", this.contacto);
      this.splitintereses2(this.contacto);

      if (this.msg == '') {
        for (var propName in this.contacto) {
          if (!this.contacto[propName] || this.contacto[propName] === null || this.contacto[propName] === undefined) {
            delete this.contacto[propName];
          } 
        }
        this.contacto.canal_id = this.canal.id;
        if (this.contacto.id) {
          this.contacto.contacto_id = this.contacto.id;
          delete this.contacto.id;
          this.actualizar();
        } else {
          this.subir();
        }
      }
    },
    splitintereses2(contacto) {
      if (!contacto.intereses) {
        this.msg += 'Interes no valido';
        return;
      }
      const partes = contacto.intereses.split(',');
      // window.console.log('--------------', contacto.intereses, partes);
      const ints = [];
      partes.forEach(function (e) {
        let interes = e.trim();
        if (interes.length > 150) this.msg += 'Interes no valido';
        ints.push({ nombre: interes });
      });
      contacto.intereses = ints;
    },
    mergetextintereses2(intereses) {
      if (!intereses) return '';
      var txt = '';
      intereses.forEach(function (e) {
        txt += e.nombre + ', ';
      });
      if (txt.length > 0) {
        txt = txt.substring(0, txt.length - 2);
      }

      return txt;
    },
    async subir() {
      //var myHeaders = new Headers();
      //myHeaders.append('Content-Type', 'application/json');
      const xcontactos = [];
      xcontactos.push(this.contacto);

      var raw = JSON.stringify(xcontactos);
      window.console.log(raw);
      const vue = this;
      this.subiendo = true;
      this.msg = 'Enviando datos...';

      let myHeaders = getheadersrest();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      fetch(process.env.VUE_APP_API_REST + '/api/esam/contactos', requestOptions)
        .then((response) => response.json())
        .then((result) => {
          window.console.log(result);
          if (result.result) {
            vue.msg = 'Contacto subido correctamente.';
            if (vue.listado) {
              const newcontacto = window.Object.assign({}, vue.contacto);
              //newcontacto.interes = vue.splitintereses2( newcontacto );
              vue.listado.unshift(newcontacto);
              this.$emit("success")
            }
          } else {
            var txt = '';
            result.errors.forEach(function (e) {
              txt += e + '\n';
            });
            vue.msg = txt;
          }
          vue.subiendo = false;
          vue.contacto.intereses = vue.mergetextintereses2(vue.contacto.intereses);
        })
        .catch(() => {
          // window.console.log('error', error);
          vue.subiendo = false;
          vue.contacto.intereses = vue.mergetextintereses2(vue.contacto.intereses);
        });
    },
    async actualizar() {
      let myHeaders = getheadersrest();
      /*var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');*/

      var raw = JSON.stringify(this.contacto);
      window.console.log(raw);
      const vue = this;
      this.subiendo = true;
      this.msg = 'Enviando datos...';

      var requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      fetch(process.env.VUE_APP_API_REST + '/api/esam/contacto', requestOptions)
        .then((response) => response.json())
        .then((result) => {
          window.console.log(result);
          if (result.result) {
            vue.msg = 'Contacto actualizado correctamente.';
            vue.padre.numero_documento = vue.contacto.numero_documento;
            vue.padre.nombres = vue.contacto.nombres;
            vue.padre.primer_apellido = vue.contacto.primer_apellido;
            vue.padre.segundo_apellido = vue.contacto.segundo_apellido;
            vue.padre.telefono = vue.contacto.telefono;
            vue.padre.correo = vue.contacto.correo;
            vue.padre.empresa = vue.contacto.empresa;
            vue.padre.profesion = vue.contacto.profesion;
            vue.padre.asesor_id = vue.contacto.asesor_id;
            vue.padre.fecha_visita = vue.contacto.fecha_visita;
            vue.padre.estado = vue.contacto.estado;
            vue.padre.latitud = vue.contacto.latitud;
            vue.padre.longitud = vue.contacto.longitud;
            vue.padre.ciudad = vue.contacto.ciudad;
            vue.padre.direccion = vue.contacto.direccion;
            vue.padre.observacion = vue.contacto.observacion;
            vue.padre.intereses = vue.contacto.intereses;
          } else {
            vue.msg = result.error;
            vue.contacto.id = vue.contacto.contacto_id;
          }
          vue.subiendo = false;
          vue.contacto.intereses = vue.mergetextintereses2(vue.contacto.intereses);
        })
        .catch(() => {
          // window.console.log('error', error);
          vue.subiendo = false;
          vue.contacto.intereses = vue.mergetextintereses2(vue.contacto.intereses);
        });
    },
    reset() {
      delete this.contacto.contacto_id;
      delete this.contacto.id;
      this.contacto.numero_documento = '';
      this.contacto.nombres = '';
      this.contacto.primer_apellido = '';
      this.contacto.segundo_apellido = '';
      this.contacto.telefono = '';
      this.contacto.correo = '';
      this.contacto.asesor_id = '';
      this.contacto.fecha_visita = '';
      this.contacto.estado = 'Interesado';
      this.contacto.latitud = '';
      this.contacto.longitud = '';
      this.contacto.ciudad = '';
      this.contacto.profesion = '';
      this.contacto.empresa = '';
      this.contacto.intereses = '';
      this.contacto.direccion = '';
      this.contacto.observacion = '';
      this.city = null;
      this.profesion = null;
      this.postgrado = null;
    },
    loadc() {
      this.reset();
      if (!this.padre) return;
      this.contacto = window.Object.assign({}, this.padre);
      this.city = this.padre.ciudad ? this.padre.ciudad : null;
      this.profesion = this.padre.profesion ? this.padre.profesion : null;
      this.empresa = this.padre.empresa ? this.padre.empresa : null;
      this.postgrado = this.padre.intereses ? this.padre.intereses : null;
      this.contacto.intereses = this.mergetextintereses2(this.contacto.intereses);
      window.console.log('this.padre', this.padre);
    },
    getCiudades() {
      const sql = gql`query { getCiudades ${''} { id nombre }}`;
      this.$apollo.query({ query: sql }).then(({ data: { getCiudades } }) => (this.ciudades = getCiudades));
    },
    getEmpresas() {
      const sql = gql`query { getEmpresas ${''} { id nombre }}`;
      this.$apollo.query({ query: sql }).then(({ data: { getEmpresas } }) => (this.empresas = getEmpresas));
    },
    getProfesiones() {
      const sql = gql`query { getProfesiones ${''} { id nombre } }`;
      this.$apollo.query({ query: sql }).then(({ data: { getProfesiones } }) => (this.profesiones = getProfesiones));
    },
    getPostgrados(name = null) {
        this.pordefecto();
      const sql = gql`query { getPostgrados ${name ? `(nombre: "${name}")` : ''} { id nombre }}`;
      this.$apollo.query({ query: sql }).then(({ data: { getPostgrados } }) => {
        this.postgrados = this.postgrados.concat(getPostgrados)
      });
    },
  },
  mounted() {
    // this.contacto.fecha_visita = '2024-09-06'
    const vue = this;
    window.$('#modal-contacto').on('show.bs.modal', function () {
      vue.msg = '';
      vue.loadc();
      vue.pordefecto();
      vue.contacto.fecha_visita = vue.formatDate(vue.date);
    });
  },
};
</script>
